import { forecastDataType } from "../schemas/prevision-data-schema";

export const getLocalMonthDay = (date: Date) => {
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const day = String(date.getDate()).padStart(2, "0");
	return `${month}-${day}`;
};

export const getForecastByDate = ({
	forecastData,
	selectedDate,
}: {
	selectedDate: Date;
	forecastData: forecastDataType[];
}): forecastDataType[] => {
	const now = new Date();

	const selectedDay = `${selectedDate.getFullYear()}-${String(
		selectedDate.getMonth() + 1,
	).padStart(2, "0")}-${String(selectedDate.getDate()).padStart(2, "0")}`;

	const sameDayData = forecastData.filter((forecast) => {
		return forecast.timestep.slice(0, 10) === selectedDay;
	});

	const sorted = sameDayData.sort(
		(a, b) => new Date(a.timestep).getTime() - new Date(b.timestep).getTime(),
	);

	return sorted.filter((item, index) => {
		const currentTime = new Date(item.timestep);
		const nextItem = sorted[index + 1];
		const nextTime = nextItem ? new Date(nextItem.timestep) : null;

		if (!nextTime) {
			return currentTime >= now;
		}

		if (currentTime <= now && now < nextTime) {
			return true;
		}

		if (currentTime > now) {
			return true;
		}

		return false;
	});
};

export const getSingleForecastByDate = ({
	date,
	forecastData,
}: {
	date: Date;
	forecastData: forecastDataType[] | undefined;
}): forecastDataType | undefined => {
	if (!forecastData || forecastData?.length === 0) return;

	const target = date.getTime();

	return forecastData.reduce((closest, current) => {
		const currentTime = new Date(current.timestep).getTime();
		const closestTime = new Date(closest.timestep).getTime();

		const currentDiff = Math.abs(currentTime - target);
		const closestDiff = Math.abs(closestTime - target);

		return currentDiff < closestDiff ? current : closest;
	});
};
